import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleFieldConfig } from '../simple-field.interface';
@Component({
  selector: 'calsoft-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit{
  field: SimpleFieldConfig;
  group: UntypedFormGroup;
  formType: any;
  constructor() {}
  optionsList: string[];
 valueChange = new EventEmitter();
  ngOnInit() {

    let value:any= this.field.options;
    this.optionsList = (value || '').split(',').map(s => s.trim());
    console.log(this.field.options);

  
    
  }
}
